/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable import/no-unresolved */

import { useEffect, useRef } from 'react';
import {
  Navigation, Pagination, Autoplay, Keyboard, A11y,
} from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/a11y';
import DOMPurify from 'dompurify';
import './heroSection.scss';
import { NextIcon, PrevIcon } from 'components/atoms/Icons/iconList';
import { CTAButton } from 'components/atoms/Button/Button';
import { goToCustomUrl } from 'controls/utils';
import {
  useIsMobile, getResponsiveImageUrl, focusSlideIntoView,
} from 'helpers/ui';
import { FallbackImage } from '@rcw/ui';
import PropTypes from 'prop-types';

export default function HeroSection({ data }) {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const heroData = data.elements.sort((a, b) => a.order - b.order).filter((e) => e.enabled);
  const isMobile = useIsMobile(768);
  const swiperRef = useRef(null);

  useEffect(() => {
    if (
      swiperRef.current
      && swiperRef.current.params
      && prevRef.current
      && nextRef.current
    ) {
      swiperRef.current.params.navigation.prevEl = prevRef.current;
      swiperRef.current.params.navigation.nextEl = nextRef.current;

      swiperRef.current.navigation.destroy();
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, [swiperRef.current, prevRef.current, nextRef.current]);

  return (
    <div className='hero' onFocus={(e) => focusSlideIntoView(swiperRef.current, e.target)}>
      <Swiper
        modules={[Navigation, Pagination, Autoplay, Keyboard, A11y]}
        slidesPerView={1}
        pagination={{ clickable: true }}
        loop
        speed={600}
        autoplay={false}
        // autoplay={{ delay: 3000, disableOnInteraction: false }}
        keyboard={{ enabled: true, onlyInViewport: true }}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
        }}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
      >
        {heroData.map((element, idx) => (
          <SwiperSlide key={element.imageUrl || idx}>
            <div
              className='carouselItemWrapper flex'
              style={{ justifyContent: element.alignment }}
            >
              <div className={`heroOverlay heroOverlay--${element.alignment}`} />

              <div
                className='elementDataContainer'
                style={{
                  textAlign: element.alignment,
                  alignItems: element.alignment,
                }}
              >
                <div className='elementDataContainer_topTitle' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(element.topTitle) }} />
                <div
                  className='elementDataContainer_title proxima-nova-bold'
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(element.title) }}
                />
                <div className='elementDataContainer_body' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(element.body) }} />

                <div className='flex' style={{ justifyContent: element.alignment }}>
                  <CTAButton
                    ctaText={element.ctaText}
                    onClick={() => goToCustomUrl(element.ctaUrl)}
                  />
                </div>
              </div>

              <FallbackImage
                imgClassName='carouselImg'
                src={getResponsiveImageUrl(
                  element.imageUrl,
                  element.mobileImageUrl,
                  isMobile,
                )}
                fallbackSrc={element.imageUrl}
                alt={`slide-${idx + 1}`}
                fetchPriority='high'
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <button
        type='button'
        ref={prevRef}
        className='carouselControl prev'
        aria-label='Previous slide'
      >
        <PrevIcon />
      </button>
      <button
        type='button'
        ref={nextRef}
        className='carouselControl next'
        aria-label='Next slide'
      >
        <NextIcon />
      </button>
    </div>
  );
}

HeroSection.propTypes = {
  data: PropTypes.shape({
    elements: PropTypes.arrayOf(
      PropTypes.shape({
        topTitle: PropTypes.string,
        title: PropTypes.string,
        body: PropTypes.string,
        ctaText: PropTypes.string,
        ctaUrl: PropTypes.string,
        imageUrl: PropTypes.string,
        mobileImageUrl: PropTypes.string,
        alignment: PropTypes.string,
      }),
    ),
  }),
};
